import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
  alt: string;
  icon: string;
  features: string[];
  caseStudyCount: number;
  responseTime: string;
  onLearnMore: () => void;
}

export default function ServiceCard({
  title,
  description,
  image,
  alt,
  icon,
  features,
  caseStudyCount,
  responseTime,
  onLearnMore,
}: ServiceCardProps) {
  return (
    <div className="bg-card rounded-lg shadow-subtle overflow-hidden transition-all duration-300 hover:shadow-modal hover:-translate-y-1">
      <div className="relative h-48 overflow-hidden">
        <AppImage
          src={image}
          alt={alt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 right-4 bg-primary text-primary-foreground rounded-full p-3">
          <Icon name={icon as any} size={24} />
        </div>
      </div>

      <div className="p-6">
        <h3 className="text-xl font-headline font-bold text-primary mb-3">
          {title}
        </h3>
        <p className="text-sm font-body text-textSecondary mb-4 line-clamp-3">
          {description}
        </p>

        <div className="space-y-2 mb-4">
          {features.slice(0, 3).map((feature, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon
                name="CheckCircleIcon"
                size={16}
                className="text-success mt-0.5 flex-shrink-0"
              />
              <span className="text-xs font-body text-textPrimary">
                {feature}
              </span>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center space-x-4 text-xs font-body text-textSecondary">
            <div className="flex items-center space-x-1">
              <Icon name="DocumentTextIcon" size={14} />
              <span>{caseStudyCount} Case Studies</span>
            </div>
            <div className="flex items-center space-x-1">
              <Icon name="ClockIcon" size={14} />
              <span>{responseTime}</span>
            </div>
          </div>
        </div>

        <button
          onClick={onLearnMore}
          className="w-full mt-4 px-4 py-2 bg-secondary text-secondary-foreground rounded-md text-sm font-cta font-semibold transition-all duration-300 hover:bg-primary hover:shadow-subtle"
        >
          Learn More
        </button>
      </div>
    </div>
  );
}